/** Полный URL STOMP WebSocket для клиентского чата */
export const chatWsUrl = "wss://chat-ru.d-keys.info:8765/ws";
/** Путь регистрации клиента после подключения к WS */
export const chatRegisterDestination = "/app/user.register";

/** Путь отправки сообщения клиентом */
export const chatSendDestination = "/app/user.sendMessage";

/** Базовый префикс пользовательских топиков */
export const chatUserTopicPrefix = "/topic/user";

/** Максимум сообщений в ленте */
export const maxChatMessages = 50;
